"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.LINK_ICON_SPACING = void 0;

var _interfaces = require("./interfaces");

var defaultProps = {
  color: 'primary70',
  fontWeight: 'medium',
  textDecoration: 'underline',
  iconPosition: _interfaces.LinkIconPosition.Trailing,
  iconVerticalAlign: 'text-top'
};
exports.defaultProps = defaultProps;
var LINK_ICON_SPACING = 4;
exports.LINK_ICON_SPACING = LINK_ICON_SPACING;